/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-class-card.vue?vue&type=template&id=310946c3&scoped=true"
import script from "./j-class-card.vue?vue&type=script&lang=js"
export * from "./j-class-card.vue?vue&type=script&lang=js"
import style0 from "./j-class-card.vue?vue&type=style&index=0&id=310946c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310946c3",
  null
  
)

export default component.exports
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QScrollArea,QIcon});
